import { render, staticRenderFns } from "./TopicLevelCategory.vue?vue&type=template&id=61dbc119&scoped=true&"
import script from "./TopicLevelCategory.vue?vue&type=script&lang=js&"
export * from "./TopicLevelCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dbc119",
  null
  
)

export default component.exports